import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Titlebar element, used dislpay the page title
 *
 * @slot - Unnamed slot (default)
 * @slot backButton - used to display an iconbutton
 *
 * @prop {String} headline - Mandatory, used to define the title (text)
 *
 */
let SDBNavTitleBar = class SDBNavTitleBar extends LitElement {
    constructor() {
        super(...arguments);
        this.headline = '';
    }
    render() {
        return html `
            <div class="backButton" part="back-button">
                <slot name="backButton"></slot>
            </div>
            <div class="pageTitle" part="page-title">
                ${this.headline ? html `${this.headline}` : html ``}<slot></slot>
            </div>
        `;
    }
};
SDBNavTitleBar.styles = [
    elements,
    css `
            :host {
                display: grid;
                grid-template-columns: auto 1fr;
                height: auto;
                color: var(--text-primary);
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    width: auto;
                }
            }

            :host div.backButton {
                grid-column: 1;
                justify-self: start;
                line-height: 50px;
            }

            :host div.pageTitle {
                grid-column: 2;
                font-size: 1.3em;
                font-weight: 300;
                line-height: 50px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBNavTitleBar.prototype, "headline", void 0);
SDBNavTitleBar = __decorate([
    customElement('sdb-nav-titlebar')
], SDBNavTitleBar);
export { SDBNavTitleBar };
//# sourceMappingURL=sdb-nav-titlebar.js.map